module.exports = __webpack_public_path__ + "img/empty.7897a876.png";